import React, { Component } from 'react';
import RangeInput from '../../shared/RangeInput';
import { tensionerForceRange } from '../../helpers/GlobalFunctions';
import ErrorMsgBlockComponent from '../Error/ErrorMessageBlock';
import CasePullDropdown from './CasePullDropdown';
import TKAResultBoxes from './TKAResultBoxes';
export default class TKAPlanningReviewTool extends Component {
	constructor(props) {
		super(props);
		this.state = {
			initialState: true,
			disableButtons: true,
			showFilters: true,
			casePull: 'myCases',
			casePullValue: 'My Cases',
			casePull2: 'globalCases',
			casePull2Value: 'Global Cases',
			implantValue: '',
			gapsDataValue: '',
			patientAge: [],
			preopDeformity: [],
			femurSize: [],
			patientSex: [],
			tensionerForce: ['high', 'medium', 'low'],
			isAllSexChecked: true,
			checkBoxes: [
				{ value: 'Male', checked: false },
				{ value: 'Female', checked: false },
				{ value: 'Other', checked: false }
			],
			tensionerForceCheckbox: [
				{ value: 'high', checked: true },
				{ value: 'medium', checked: true },
				{ value: 'low', checked: true }
			],
			dropDownButtons: [
				{ value: 'myCases', label: 'My Cases' },
				{ value: 'globalCases', label: 'Global Cases' },
				{ value: 'country', label: 'My Country' },
				{ value: 'region', label: 'Regional' }
			]
		}
	}

	componentDidMount() {
		this.setState({ initialState: false });
	}

	/**
	* @description function to toggle filter view in UI
	* @memberof TKAPlanningReviewTool
	*/
	toggleFilter = () => {
		this.setState(prevState => {
			return {
				showFilters: !prevState.showFilters
			}
		})
	}
	/**
	* @description function to set the state for case pull dropdowns
	* @param {casePullType}
	* @memberof TKAPlanningReviewTool
	*/
	setCasePullState = (casePullType, field) => {
		let casePull = this.state.dropDownButtons.find(x => x.value === casePullType);
		this.setState({ [field]: casePullType, initialState: false, [`${field}Value`]: casePull.label });
	}

	/**
	* @description function to handle case pull data selection from filter box
	* @param {casePullType}
	* @memberof TKAPlanningReviewTool
	*/
	handleCasePull = (casePullType, field) => {
		this.setCasePullState(casePullType, field);
		this.props.handleInputChange(casePullType, field);
	}

	/**
	* @description function to handle case pull data selection from data section
	* @param {casePullType}
	* @memberof TKAPlanningReviewTool
	*/
	handleChangeSectionCasePull = (casePullType, field) => {
		this.setCasePullState(casePullType, field);
		this.props.handleChangeSection(casePullType, field);
	}

	handleChangeSectionRegion = (region, field) => {
		this.props.handleChangeSection('region', field, region);
	}

	/**
	* @description function to handle implant select change
	* @param {value, field}
	* @memberof TKAPlanningReviewTool
	*/
	handleSelectChange = (value, field) => {
		this.setState({ implantValue: value, initialState: false });
		this.props.handleInputChange(value, field);
		if (!value) {
			this.props.handleRangeChange([], 'femurSize');
		}
	}

	/**
	* @description function to handle gapscollected select change
	* @param {value, field}
	* @memberof TKAPlanningReviewTool
	*/
	handleGapscollectedChange = (value, field) => {
		this.setState({ gapsDataValue: value, initialState: false });
		this.props.handleInputChange(value, field);
	}

	/**
	* @description function to handle implant select change
	* @param {value, field}
	* @memberof TKAPlanningReviewTool
	*/
	handleRangeChange = (value, field) => {
		this.setState({ [field]: value, initialState: false });
		this.props.handleRangeChange(value, field);
	}

	/**
	* @description function to handle patient sex selection
	* @param {values, field}
	* @memberof TKAPlanningReviewTool
	*/
	handleCheckBox = (event) => {
		var value = event.target.value;
		if (value === 'All') {
			var isAllChecked = event.target.checked;
			var { checkBoxes } = this.state;
			if (isAllChecked) {
				checkBoxes.forEach(x => {
					x.checked = false;
				})
				this.setState({ isAllSexChecked: true, patientSex: [], initialState: false });
			}
			this.props.handleInputChange([], 'patientSex');
		} else {
			this.handlePatientSexSelection(value);
		}
	}

	/**
	* @description function to handle checkboxes for patient sex
	* @param {value}
	* @memberof TKAPlanningReviewTool
	*/
	handlePatientSexSelection = (value) => {
		var { checkBoxes } = this.state;
		var checkBox = checkBoxes.find(x => x.value === value);
		checkBox.checked = !checkBox.checked;
		var checkedList = checkBoxes.filter(x => x.checked).map(x => x.value);
		this.setState({ isAllSexChecked: checkedList.length === 0, patientSex: checkedList, initialState: false });
		this.props.handleInputChange(checkedList, 'patientSex');
	}

	/**
	* @description function to handle tensioner force range selection
	* @param {values, field}
	* @memberof TKAPlanningReviewTool
	*/
	handleCheckBoxTensioner = (event) => {
		var value = event.target.value;
		this.setState({ tensionerForce: value, initialState: false });
		this.props.handleInputChange([], 'tensionerForce');
		this.handletensionerForceSelection(value);
	}

	/**
	* @description function to handle tensioner force checboxes
	* @param {values, field}
	* @memberof TKAPlanningReviewTool
	*/
	handletensionerForceSelection = (value) => {
		var { tensionerForceCheckbox } = this.state;
		var checkBox = tensionerForceCheckbox.find(x => x.value === value);
		checkBox.checked = !checkBox.checked;
		var checkedList = tensionerForceCheckbox.filter(x => x.checked).map(x => x.value);
		this.setState({ tensionerForce: checkedList, initialState: false });
		this.props.handleInputChange(checkedList, 'tensionerForce');
	}

	/**
	 * @description function to handle reset of filters
	 * @param {*}
	 * @memberof TKAPlanningReviewTool
	 */
	handleReset = () => {
		this.setState({
			initialState: true,
			casePull: 'myCases',
			casePullValue: 'My Cases',
			casePull2: 'globalCases',
			casePull2Value: 'Global Cases',
			implantValue: '',
			gapsDataValue: '',
			patientSex: [],
			patientAge: [],
			preopDeformity: [],
			femurSize: [],
			tensionerForce: ['high', 'medium', 'low'],
			checkBoxes: [
				{ value: 'Male', checked: false },
				{ value: 'Female', checked: false },
				{ value: 'Other', checked: false }
			],
			tensionerForceCheckbox: [
				{ value: 'high', checked: true },
				{ value: 'medium', checked: true },
				{ value: 'low', checked: true }
			]
		});
		this.props.handleReset();
	}

	render() {
		const { showFilters, casePull, casePullValue, casePull2, casePull2Value, dropDownButtons, initialState, patientSex, isAllSexChecked, implantValue, 
			gapsDataValue, tensionerForce, patientAge, preopDeformity, femurSize } = this.state;
		const { caseData, caseData2, implants, regions, selectedRegion, selectedRegion2, femurSizeRange, showResults, handleInputChange, handleSubmit,
			error, disableReset, defaults, planningToolError, planningToolError2, handleChangeSection } = this.props;

		return (
			<div className="planning-review-tool">
				<div className="dashboard-blocks">
					<div className="dashboard-blocks-body planning-review-body">
						<div className="row">
							<div className="col-6">
								<div className="dashboard-block-title px-2">Planning Tool</div>
							</div>
							<div className="col-6 text-end">
								<button className="btn btn-primary btn-toggle-planning-tool-filter me-2" data-testid="btn-hide-filter" id="btn-hide-filter" onClick={this.toggleFilter}>{showFilters ? 'Hide' : 'Show'} Filters</button>
							</div>
						</div>


						{error && <>
							<div className="planning-tool-inner-block px-2">
								<div className="row">
									<div className="col-sm-12">
										<ErrorMsgBlockComponent className="p-0 m-0 planning-tool-error" errorObject={{ message: error }} />
									</div>
								</div>
							</div>
						</>}

						{/* FILTERS */}
						{showFilters && <>
							<div className="planning-tool-inner-block p-2">
								<div className="row">
									<div className="col-sm-4">
										<div className="form-group">
											<label className="mb-1">Implant <span className="mandatory">*</span></label>
											<select id="implant-select" data-testid="implant-select" className="form-select" name="implant" value={implantValue} onChange={(event) => this.handleSelectChange(event.target.value, 'implant')}>
												<option value="">Select Implant</option>
												{implants && implants.length ? implants.map((implant, index) => {
													return <option key={index} value={implant.name}>{implant.name}</option>;
												}) : ''}
											</select>
										</div>
										{implantValue &&
											<div className="form-group">
												<label className="mb-1" id="femur-size" aria-labelledby="femur-size" htmlFor='femur-size'>Femur Size</label>
												<RangeInput
													id="femur-size"
													data-testid="femur-size"
													step="1"
													showExtremeLabels={true}
													minExtremeLabel={femurSizeRange ? femurSizeRange.min : defaults.femurSize.min}
													maxExtremeLabel={femurSizeRange ? femurSizeRange.max : defaults.femurSize.max}
													min={femurSizeRange ? femurSizeRange.min : defaults.femurSize.min}
													max={femurSizeRange ? femurSizeRange.max : defaults.femurSize.max}
													minVal={femurSizeRange ? femurSizeRange.min : defaults.femurSize.min}
													maxVal={femurSizeRange ? femurSizeRange.max : defaults.femurSize.max}
													values={femurSize}
													reset={initialState}
													implantValue={implantValue}
													handleChange={(values) => this.handleRangeChange(values, 'femurSize')}
												/>
											</div>}
									</div>
									<div className="col-sm-4 border-lr">
										<div className="form-group">
											<label className="mb-1">Patient Sex</label>
											<div className="d-flex align-items-center justify-content-between patient-sex-wrap">
												<div className="form-check">
													<input type="checkbox" className="form-check-input" id="sex-all" value="All" name="patientsex" checked={isAllSexChecked} onChange={this.handleCheckBox} />
													<label className="form-check-label" htmlFor="sex-all">All</label>
												</div>

												<div className="form-check">
													<input type="checkbox" className="form-check-input" data-testid="sex-male" id="sex-male" value="Male" name="patientsex" checked={patientSex.indexOf('Male') > -1} onChange={this.handleCheckBox} />
													<label className="form-check-label" htmlFor="sex-male">Male</label>
												</div>

												<div className="form-check">
													<input type="checkbox" className="form-check-input" id="sex-female" value="Female" name="patientsex" checked={patientSex.indexOf('Female') > -1} onChange={this.handleCheckBox} />
													<label className="form-check-label" htmlFor="sex-female">Female</label>
												</div>

												<div className="form-check">
													<input type="checkbox" className="form-check-input" id="sex-other" value="Other" name="patientsex" checked={patientSex.indexOf('Other') > -1} onChange={this.handleCheckBox} />
													<label className="form-check-label" htmlFor="sex-other">Other</label>
												</div>
											</div>
										</div>
										<div className="form-group">
											<label className="mb-1">Patient Age</label>
											<RangeInput
												id="patient-age"
												data-testid="patient-age"
												step="1"
												showExtremeLabels={true}
												openRange={true}
												minExtremeLabel={defaults.patientAge.min}
												maxExtremeLabel={defaults.patientAge.maxLabel}
												min={defaults.patientAge.min}
												max={defaults.patientAge.max}
												minVal={defaults.patientAge.min}
												maxVal={defaults.patientAge.max}
												values={patientAge}
												openMinLabel="0"
												openMaxLabel="> 100"
												reset={initialState}
												handleChange={(values) => this.handleRangeChange(values, 'patientAge')}
											/>
										</div>
									</div>
									<div className="col-sm-4">
										<div className="form-group">
											<label className="mb-1">Deformity</label>
											<RangeInput
												id="preop-deformity"
												data-testid="preop-deformity"
												step="1"
												min={defaults.preopDeformity.min}
												max={defaults.preopDeformity.max}
												openRange={true}
												showExtremeLabels={true}
												minExtremeLabel="Valgus"
												maxExtremeLabel="Varus"
												openMinLabel="< -7"
												openMaxLabel="> 7"
												minVal={defaults.preopDeformity.minVal}
												maxVal={defaults.preopDeformity.maxVal}
												values={preopDeformity}
												reset={initialState}
												handleChange={(values) => this.handleRangeChange(values, 'preopDeformity')}
											/>
										</div>
										<div className="form-group">
											<label className="mb-1">Gaps Collected</label>
											<select data-testid="gaps-select" id="gaps-select" className="form-select" value={gapsDataValue} onChange={(event) => this.handleGapscollectedChange(event.target.value, 'gapsCollectedPlanningTool')}>
												<option value="">All</option>
												<option value="Manual">Manual</option>
												<option value="Tensioner">Tensioner</option>
											</select>
										</div>
										{gapsDataValue && gapsDataValue === 'Tensioner' ?
											<div className={`form-group ${implantValue ? 'mt-2' : ''}`}>
												<label className={implantValue ? "mb-1" : "mb-3"}>Tensioner Force</label>
												<div className="d-flex align-items-center justify-content-between tensioner-force-wrap">
													<div className="form-check">
														<input type="checkbox" className="form-check-input" data-testid="force-high" id="force-high" value="high" name="forcerange" checked={tensionerForce.indexOf('high') > -1} onChange={this.handleCheckBoxTensioner} />
														<label className="form-check-label" htmlFor="force-high">{tensionerForceRange(150)}</label>
													</div>

													<div className="form-check">
														<input type="checkbox" className="form-check-input" id="force-medium" value="medium" name="forcerange" checked={tensionerForce.indexOf('medium') > -1} onChange={this.handleCheckBoxTensioner} />
														<label className="form-check-label" htmlFor="force-medium">{tensionerForceRange(100)}</label>
													</div>

													<div className="form-check">
														<input type="checkbox" className="form-check-input" id="force-low" value="low" name="forcerange" checked={tensionerForce.indexOf('low') > -1} onChange={this.handleCheckBoxTensioner} />
														<label className="form-check-label" htmlFor="force-low">{tensionerForceRange(50)}</label>
													</div>
												</div>
											</div>
											: ''}
									</div>
								</div>
								<div className="row mt-3">
									<div className="col-sm-6">
										{!showResults &&
											<div className="case-pull-wrap d-flex align-items-center">
												<CasePullDropdown
													dropDownButtons={dropDownButtons}
													casePull={casePull}
													casePullValue={casePullValue}
													regions={regions}
													selectedRegion={selectedRegion}
													disableCasePull={casePull2}
													disableRegion={casePull2 === 'region' ? selectedRegion2 : ''}
													handleCasePull={(value) => this.handleCasePull(value, 'casePull')}
													handleInputChange={(value) => handleInputChange(value, 'selectedRegion')}
												/>
												<span className="mx-2">VS</span>
												<CasePullDropdown
													dropDownButtons={dropDownButtons}
													casePull={casePull2}
													casePullValue={casePull2Value}
													regions={regions}
													selectedRegion={selectedRegion2}
													disableCasePull={casePull}
													disableRegion={casePull === 'region' ? selectedRegion : ''}
													handleCasePull={(value) => this.handleCasePull(value, 'casePull2')}
													handleInputChange={(value) => handleInputChange(value, 'selectedRegion2')}
												/>
											</div>
										}
									</div>
									<div className="col-sm-6">
										<div className="d-flex align-items-center justify-content-end">
											<button className="btn btn-primary me-2" data-testid="btn-apply" id="btn-apply" onClick={handleSubmit}>Apply</button>
											<button className="btn btn-primary" data-testid="btn-reset" id="btn-reset" disabled={disableReset} onClick={this.handleReset}>Reset</button>
										</div>
									</div>
								</div>
							</div>
						</>}
					</div>
				</div>

				{/* DATA DISPLAY */}
				{showResults && <>
					<div className="planning-tool-result-block mt-2">
						<div className="planning-review-body">
							{/* SECTION 1 START */}
							<TKAResultBoxes
								dropDownButtons={dropDownButtons}
								casePull={casePull}
								casePullValue={casePullValue}
								regions={regions}
								selectedRegion={selectedRegion}
								disableCasePull={casePull2}
								disableRegion={casePull2 === 'region' ? selectedRegion2 : ''}
								handleCasePull={(value) => this.handleChangeSectionCasePull(value, 'casePull')}
								handleInputChange={(value) => handleChangeSection('region', 'selectedRegion', value)}
								caseData={caseData}
								planningToolError={planningToolError}
							/>
							{/* SECTION 1 END */}

							{/* SECTION 2 START */}
							<TKAResultBoxes
								dropDownButtons={dropDownButtons}
								casePull={casePull2}
								casePullValue={casePull2Value}
								regions={regions}
								selectedRegion={selectedRegion2}
								disableCasePull={casePull}
								disableRegion={casePull === 'region' ? selectedRegion : ''}
								handleCasePull={(value) => this.handleChangeSectionCasePull(value, 'casePull2')}
								handleInputChange={(value) => handleChangeSection('region', 'selectedRegion2', value)}
								caseData={caseData2}
								planningToolError={planningToolError2}
							/>
							{/* SECTION 2 END */}
						</div>
					</div>
				</>}
			</div>
		)
	}
}
